import * as AccountingConnectionActions from "./accountingConnectionActions";
import * as ActivityCategoryActions from "./activityCategoryActions";
import * as ActivityTypeActions from "./activityTypeActions";
import * as AddressActions from "./addressActions";
import * as AnswerActions from "./answerActions";
import * as BankAccountActions from "./bankAccountActions";
import * as BlackoutActions from "./blackoutActions";
import * as CampaignActions from "./campaignActions";
import * as CaseTypeActions from "./caseTypeActions";
import * as CaseTypeStageActions from "./caseTypeStageActions";
import * as CategoryActions from "./categoryActions";
import * as CommentActions from "./commentActions";
import * as ConflictActions from "./conflictActions";
import * as ContactActions from "./contactActions";
import * as CourtActions from "./courtActions";
import * as CourtDeadlineRuleActions from "./courtDeadlineRuleActions";
import * as DeadlineActions from "./deadlineActions";
import * as DeadlineRuleActions from "./deadlineRuleActions";
import * as DiscountActions from "./discountActions";
import * as DocketActions from "./docketActions";
import * as DocumentActions from "./documentActions";
import * as EntityTimestampActions from "./entityTimestampActions";
import * as EventActions from "./eventActions";
import * as ExpenseActions from "./expenseActions";
import * as FirmActions from "./firmActions";
import * as FlatFeeActions from "./flatFeeActions";
import * as FlatFeeMilestoneActions from "./flatFeeMilestoneActions";
import * as GroupActions from "./groupActions";
import * as HolidayCalendarActions from "./holidayCalendarActions";
import * as IdentificationActions from "./identificationActions";
import * as ImportExportActions from "./importExportActions";
import * as ImportSourceActions from "./importSourceActions";
import * as InvoiceActions from "./invoiceActions";
import * as InvoiceBatchActions from "./invoiceBatchActions";
import * as InvoiceBatchItemActions from "./invoiceBatchItemActions";
import * as LeadActions from "./leadActions";
import * as LookupActions from "./lookupActions";
import * as MatterActions from "./matterActions";
import * as MatterStageActions from "./matterStageActions";
import * as MilestoneActions from "./milestoneActions";
import * as OptionActions from "./optionActions";
import * as ParticipantActions from "./participantActions";
import * as PrivilegeActions from "./privilegeActions";
import * as QuestionActions from "./questionActions";
import * as RedFlagActions from "./redFlagActions";
import * as RedFlagTypeActions from "./redFlagTypeActions";
import * as ReferralActions from "./referralActions";
import * as ResourceActions from "./resourceActions";
import * as RoleActions from "./roleActions";
import * as TaskActions from "./taskActions";
import * as TemplateTaskActions from "./templateTaskActions";
import * as TimeOffActions from "./timeOffActions";
import * as TransactionActions from "./transactionActions";
import * as UserActions from "./userActions";
export default {AccountingConnectionActions,ActivityCategoryActions,ActivityTypeActions,AddressActions,AnswerActions,BankAccountActions,BlackoutActions,CategoryActions,CampaignActions,DocketActions,MatterActions,CommentActions,CaseTypeActions,CaseTypeStageActions,DeadlineActions,DeadlineRuleActions,ConflictActions,ContactActions,CourtActions,CourtDeadlineRuleActions,DiscountActions,EntityTimestampActions,DocumentActions,ExpenseActions,EventActions,FirmActions,FlatFeeActions,FlatFeeMilestoneActions,GroupActions,HolidayCalendarActions,IdentificationActions,ImportExportActions,ImportSourceActions,InvoiceActions,InvoiceBatchActions,InvoiceBatchItemActions,LeadActions,LookupActions,MatterStageActions,MilestoneActions,OptionActions,ParticipantActions,PrivilegeActions,QuestionActions,RedFlagTypeActions,RedFlagActions,ResourceActions,ReferralActions,RoleActions,TaskActions,TemplateTaskActions,TimeOffActions,TransactionActions,UserActions};